import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
const panels = document.querySelectorAll('.awards_wrapper .panel');

const isMobile = () => {
    return window.innerWidth <= 768; // Możesz dostosować wartość do swoich potrzeb
};

if (isMobile()) {
    const scrollEndValue = -panels.length * 1500;
    const t1 = gsap.timeline({
        scrollTrigger: {
            trigger: '.awards_wrapper',
            scrub: 4,
            snap: 0,
            start: 'top +77',
            end: `bottom ${scrollEndValue}`,
            anticipatePin: 0,
            pin: true,
            markers: false,
            fastScrollEnd: 300000000,
        },
    });

    panels.forEach((panel, index) => {
        const currentPanel = index + 1;

        const panelId = `panel${currentPanel}`;
        const nextPanelId = `panel${currentPanel + 1}`;
        const newtextContent = $(`.${nextPanelId} .text`).html();
        const newImagesContent = $(`.${nextPanelId} .images`).html();

        if (currentPanel == 1) {
            t1.add([
                gsap.fromTo(
                    '.text',
                    { opacity: 1, x: 0 },
                    { delay:1, duration: 2, opacity: 0, x: -400, ease: 'power1.out' },
                ),
            ]).add([
                gsap.fromTo(
                    '.awards_wrapper .images',
                    { opacity: 0, x: -400 },
                    { duration: 2, opacity: 1, x: 0, ease: 'power1.out' },
                ),
            ]);
        }
        if (newtextContent && newImagesContent) {
            t1.add([
                gsap.fromTo(
                    '.awards_wrapper .images',
                    { opacity: 1, x: 0 },
                    {delay:1, duration: 2, opacity: 0, x: -400, ease: 'power1.out' },
                ),
            ])

                .set('.text', { innerHTML: newtextContent })
                .set('.awards_wrapper .images', { innerHTML: newImagesContent })

                .add([
                    gsap.fromTo(
                        '.text',
                        { opacity: 0, x: -400 },
                        { duration: 2, opacity: 1, x: 0, ease: 'power1.out' },
                    ),
                ])
                .add([
                    gsap.fromTo(
                        '.text',
                        { opacity: 1, x: 0 },
                        { delay:1, duration: 2, opacity: 0, x: -400, ease: 'power1.out' },
                    ),
                ])
                .add([
                    gsap.fromTo(
                        '.awards_wrapper .images',
                        { opacity: 0, x: -400 },
                        { duration: 2, opacity: 1, x: 0, ease: 'power1.out' },
                    ),
                ]);
        }
    });
} else {
    const scrollEndValue = -panels.length * 1500;
    const t1 = gsap.timeline({
        scrollTrigger: {
            trigger: '.awards_wrapper',
            scrub: 3,
            snap: 0,
            start: 'top +77',
            end: `bottom ${scrollEndValue}`,
            anticipatePin: 0,
            pin: true,
            markers: false,
            fastScrollEnd: 300000000,
        },
    });

    panels.forEach((panel, index) => {
        const currentPanel = index + 1;

        const panelId = `panel${currentPanel}`;
        const nextPanelId = `panel${currentPanel + 1}`;
        const newtextContent = $(`.${nextPanelId} .text`).html();
        const newImagesContent = $(`.${nextPanelId} .images`).html();
        const newBackgroundImage = $(`.${nextPanelId} .background`).html();

        if (currentPanel == 1) {
            t1
                // .from(".text", { duration: 2, opacity: 0, x:-200, ease: "power1.out" })
                // .to(".text", { duration: 2, opacity: 1, x:0, ease: "power1.out", })
                .from('.awards_wrapper .images', {
                    duration: 4,
                    y: 200,
                    opacity: 0,
                    ease: 'power1.out',
                })
                .to('.awards_wrapper .images', {
                    duration: 4,
                    y: 0,
                    opacity: 1,
                    ease: 'power1.out',
                });
        }
        if (newtextContent && newImagesContent && newBackgroundImage) {
            t1.duration(10)
                .to('.awards_wrapper .images', {
                    duration: 2,
                    y: 200,
                    opacity: 0,
                    ease: 'power1.out',
                })
                .from('.text', { duration: 1, opacity: 1, x: 0, ease: 'power1.out' })
                .to('.text', { duration: 2, opacity: 0, x: -200, ease: 'power1.out' })
                .to('.background', { duration: 2, opacity: 0, ease: 'power1.out' })
                .set('.background', { innerHTML: newBackgroundImage })
                .to('.background', { duration: 2, opacity: 1, ease: 'power1.out' })
                .set('.text', { delay: 2, innerHTML: newtextContent })
                .from('.text', { duration: 4, opacity: 0, x: -200, ease: 'power1.out' })
                .to('.text', { duration: 4, opacity: 1, x: 0, ease: 'power1.out' })
                .set('.awards_wrapper .images', { innerHTML: newImagesContent })
                .from('.awards_wrapper .images', {
                    duration: 4,
                    y: 200,
                    opacity: 0,
                    ease: 'power1.out',
                })
                .to('.awards_wrapper .images', {
                    duration: 4,
                    y: 0,
                    opacity: 1,
                    ease: 'power1.out',
                });
        }
    });
}
